import { Account } from '@fanduel/cpe-um-bundle/account/library';

import { initializeUnifiedModules } from '../unified-modules-core';
import { syncSessionToStore } from './annexes/session-manager';
import { promptAccountLogin } from './prompt-account-login';

export const CLEAR_SESSION_REASON = {
  EXPIRY_TIMER: 'launcher_expiry_timer',
  ACCOUNT_401: 'launcher_401_within_account',
  OTHER: 'launcher_other',
} as const;

let initialize: boolean | undefined | null;
let isInitializingPromise: Promise<boolean | undefined | null> | null = null;

export const initializeAccountUM = async () => {
  await Account.initialize();
};

export const initializeUM = async () => {
  if (initialize) {
    return Promise.resolve(initialize);
  }

  if (isInitializingPromise) {
    await isInitializingPromise;
    return initialize;
  }

  isInitializingPromise = (async () => {
    try {
      initialize = await initializeUnifiedModules();
      return initialize;
    } finally {
      isInitializingPromise = null;
    }
  })();

  return isInitializingPromise;
};

export const checkValidSession = async () => {
  await Account.checkValidSession();
};

export const syncCookiesUM = async (_session: unknown) => {
  syncSessionToStore();
};

export const keepAlive = () => {
  return Account.keepAlive();
};

export const isCurrentLocalSessionValid = async () => {
  await initializeUM();
  return await Account.getSessionAsync('Local');
};

/*
-----Getters for session information-----
**/

export const getSession = () => Account.getSessionAsync('Silent');

export const processSessionContext = async (): Promise<boolean> => {
  const session = await getSession();
  if (!session) return false;

  syncSessionToStore();
  return true;
};

/**
 * Did the build already establish the session itself, so the Account SDK can be
 * skipped? Always false in production; mock-harness builds alias this module to
 * seed a session and answer true.
 */
export const bootstrapMockHarnessSession = async (): Promise<boolean> => false;

export const getSessionWithLoginView = async () => {
  await initializeUM();
  // getSessionAsync("Normal") opens account login view. DOES NOT return a response!
  return promptAccountLogin({
    reason: 'explicit_login_view',
    phase: 'init',
  });
};

/**
 * @deprecated
 * This should be removed when we don't use login-token
 */
export const getLoginToken = async () => {
  await initializeUM();
  return Account.getLoginTokenAsync();
};

export const getUserData = async () => {
  await initializeUM();
  return Account.getUserAsync('Silent');
};

export const clearSession = async (reason?: string): Promise<void> => {
  return Account.clearSession(undefined, reason);
};

export const getPriorSession = () => {
  return Account.getPriorSession?.();
};
